import React, { useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";

import { BsExclamationCircleFill } from "react-icons/bs";

import AddModal from "components/Table/AddModal/AddModal";
import { useDispatch } from "react-redux";
import { getBuildingDetails } from "redux/pages/Administration/Building/buildingSlice";
import { useAppSelector } from "redux/hooks";

interface Props {
  showModal: boolean;
  setShowModal: (state: boolean) => void;
  selectedRow: any;
  onEditBuildingClick: (data: any) => void;
}

type FormData = {
  uniqueSiteId: string;
  buildingName: string;
};

export const EditBuildings: React.FC<Props> = ({
  showModal = false,
  setShowModal = () => {},
  selectedRow = [],
  onEditBuildingClick = () => {},
}) => {
  const editForm: any = useRef();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      uniqueSiteId: "",
      buildingName: "",
    },
  });

  const buildngDetails = useAppSelector((state) => state.building.buildngDetails);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    dispatch(getBuildingDetails(selectedRow[0]?.uniqueSiteId, selectedRow[0].uniqueBuildingId))
  }, [])

  useEffect(() => {
    if (buildngDetails) {
      setValue("buildingName", buildngDetails?.buildingName)
      setValue("uniqueSiteId", selectedRow[0]?.uniqueSiteId)
    }
  }, [buildngDetails])

  const formSubmitHandler = (data: any) => {
    editForm.current.requestSubmit();
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && (
        <span className="tooltip-text">
          <BsExclamationCircleFill />
          {errors[name].message}
        </span>
      )
    );
  };

  const onEditFormSubmit = (data: any) => {
    data.buildingName=data.buildingName?.trim();
    onEditBuildingClick && onEditBuildingClick(data);
  };

  const onError = (errors: any, e: any) => {};

  return (
    <>
      <AddModal
        header="Edit Building"
        showModal={showModal}
        isAdd={false}
        setShowModal={setShowModal}
        style={{ width: "35vw", height: "35vh" }}
        OnSaveClick={formSubmitHandler}
      >
        <form
          onSubmit={handleSubmit(onEditFormSubmit, onError)}
          ref={editForm}
        >
          <div className="row px-2">
            <div className="field col-12 md:col-2 mb-0">
              <span className="p-float-label text-container">
                <label htmlFor="inputtext">Site Number</label>
                <Controller
                  name="uniqueSiteId"
                  control={control}
                  render={() => <span className="text-value">{buildngDetails?.siteNumber}</span>}
                />
              </span>
            </div>
          </div>

          <div className="row px-2 pt-1 pb-2">
            <div className="field col-12 md:col-2 mb-0">
              <span className="p-float-label">
                <Controller
                  name="buildingName"
                  control={control}
                  rules={{
                    required: "Building Name is required.",
                    validate:(value) => {
                    return value?.includes(",")
                    ?"Comma is not allowed in building name":true
                     }
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id="name"
                      maxLength={100}
                      className={classNames("w-100 error-tooltip", {
                        error: fieldState.invalid,
                      })}
                      {...field}
                      onChange={(e: any) => {
                        field.onChange(e.target.value.trimStart());
                    }}
                    />
                  )}
                />
                <label className="mandatory" htmlFor="inputtext">
                  Building Name
                </label>
                {getFormErrorMessage("buildingName")}
              </span>
            </div>
          </div>
        </form>
      </AddModal>
    </>
  );
};

export default EditBuildings;
